export default {
    data() {
        window.printerC = this
        return {
            printerAlign: {
                left: '0',
                center: '1',
                right: '2',
            },
            printerTextSize: {
                normal: '00',
                reduced: '01',
                bold: '8',
            },
            textModifiers: {
                bold: '1b4501',
                underline: '1b2d01',
                font_a: '1b4d48',
                font_b: '1b4d01',
                // Demomento en desuso
                txt_underl2_on: '1b2d02',
                txt_underl_off: '1b2d00',
                txt_bold_off: '1b4500',
            },
            allowedPrinterNames: ['printer', 'd58a-2', 'mpt-ii', 'mtp-ii'],
        }
    },
    methods: {
        // Quitar los acentos pasando los caracteras a uniciode
        normalizeText(str) {
            return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        },
        async printOnBTPrinter(data) {
            if (!window.cordova) {
                this.$gestios.$message.error('Acción solo disponible para moviles')
                throw 'No esta en entorno movil, se omitira la impresión'
            }

            // desconectamos simpre primero porsiacaso
            try {
                await this.BTPDisconnect()
            } catch (e) {
                //...
            }
            // Buscamos la impresora
            try {
                const printerList = await this.BTPList()
                if (printerList.length) {
                    const printerName = printerList.find((n) =>
                        this.allowedPrinterNames.some((allow) => String(n).toLowerCase().includes(allow))
                    )
                    if (!printerName) {
                        reject('No se encontro la impresora')
                    } else {
                        await this.BTPConnect(printerName)

                        // enviamos las insttucciones de manere secuencial
                        await data.reduce((chain, row) => {
                            return chain.then(() => {
                                return new Promise((_res) => {
                                    setTimeout(() => {
                                        this.BTPPrintSpacer().finally(() => {
                                            let prs = Promise.resolve()

                                            let mods = [this.printerTextSize.normal, this.printerAlign.left]
                                            if ('modifiers' in row) {
                                                mods = row.modifiers
                                            }

                                            switch (row.type) {
                                                case 'image':
                                                    prs.then(() => this.BTPPrintB64(row.value))
                                                    break
                                                case 'text':
                                                    prs.then(() => this.BTPPrintText(this.normalizeText(row.value)))
                                                    break
                                                case 'modText':
                                                    prs.then(() => {
                                                        return this.BTPPrinModText(
                                                            this.normalizeText(row.value),
                                                            ...mods
                                                        )
                                                    })
                                                    break
                                                case 'title':
                                                    prs.then(() => this.BTPPrintTitle(this.normalizeText(row.value)))
                                                    break
                                                case 'spacer':
                                                    prs.then(() => this.BTPPrintSpacer(row.value))
                                                    break

                                                default:
                                                    break
                                            }

                                            // finalizamos
                                            prs.finally(() => _res())
                                        })
                                    }, 350)
                                })
                            })
                        }, Promise.resolve())

                        // Ponemos los espacios finales para poder recortar
                        await this.BTPPrintSpacer()
                        await this.BTPPrintSpacer()
                        await this.BTPPrintSpacer()

                        // Desconectamos y dejamos listo para otra vez
                        await this.BTPDisconnect()
                    }
                }
            } catch (e) {
                throw e
            }
        },

        // Metodos de impresion BTPrinter
        BTPList() {
            return new Promise((resolve, reject) => {
                BTPrinter.list(
                    (data) => resolve(data),
                    (err) => {
                        console.error(err)
                        reject(err)
                    }
                )
            })
        },
        BTPConnect(printerName) {
            return new Promise((resolve, reject) => {
                BTPrinter.connect(
                    (data) => resolve(data),
                    (err) => {
                        this.$gestios.$message.error('No se encontro impresora disponible')
                        console.error(err)
                        reject(err)
                    },
                    printerName
                )
            })
        },
        BTPConnected() {
            return new Promise((resolve, reject) => {
                BTPrinter.list(
                    (data) => resolve(data),
                    (err) => {
                        console.error(err)
                        reject(err)
                    }
                )
            })
        },
        BTPDisconnect() {
            return new Promise((resolve, reject) => {
                BTPrinter.disconnect(
                    (data) => resolve(data),
                    (err) => {
                        console.error(err)
                        reject(err)
                    }
                )
            })
        },
        BTPSendEncoding(encodingStr = 'ISO-8859-1') {
            return new Promise((resolve, reject) => {
                BTPrinter.setEncoding(
                    (data) => resolve(data),
                    (err) => {
                        console.error(err)
                        reject(err)
                    },
                    encodingStr
                )
            })
        },
        BTPSendPosCommand(commandStr) {
            return new Promise((resolve, reject) => {
                BTPrinter.printPOSCommand(
                    (data) => resolve(data),
                    (err) => {
                        console.error(err)
                        reject(err)
                    },
                    commandStr
                )
            })
        },
        BTPPrintB64(b64str) {
            return new Promise((resolve, reject) => {
                BTPrinter.printBase64(
                    (data) => resolve(data),
                    (err) => {
                        console.error(err)
                        reject(err)
                    },
                    b64str,
                    this.printerAlign.center
                )
            })
        },
        BTPPrintText(text) {
            return new Promise((resolve, reject) => {
                BTPrinter.printText(
                    (data) => resolve(data),
                    (err) => {
                        console.error(err)
                        reject(err)
                    },
                    text
                )
            })
        },
        BTPPrinModText(text, size = '0', align = '0') {
            return new Promise((resolve, reject) => {
                BTPrinter.printTextSizeAlign(
                    (data) => resolve(data),
                    (err) => {
                        console.error(err)
                        reject(err)
                    },
                    text,
                    size,
                    align
                )
            })
        },
        BTPPrintTitle(text) {
            return new Promise((resolve, reject) => {
                BTPrinter.printTextSizeAlign(
                    (data) => resolve(data),
                    (err) => {
                        console.error(err)
                        reject(err)
                    },
                    text,
                    this.printerTextSize.bold,
                    this.printerAlign.center
                )
            })
        },
        BTPPrintSpacer() {
            return this.BTPSendPosCommand('0A')
        },
        BTPrinterReset() {
            return this.BTPSendPosCommand('1B40')
        },
    },
}
